import axios from 'axios'
import router from '@/router/index'

export default {
  state: {
    SignInError: false,
    InSistem: false
  },
  getters: {
    getSignInError: state => state.SignInError,
    getInSistem: state => state.InSistem
  },
  mutations: {
    SetInSistem (state, val) {
      state.InSistem = val
    }
  },
  actions: {
    setSignIn ({ state, dispatch }, val) {
      axios.post(
        `${process.env.VUE_APP_URL_USERS}/Account/SignIn`,
        {
          Login: val.login,
          Password: val.password
        },
        { withCredentials: true }
      )
        .then((res) => {
          if (res.data.Succeeded) {
            if (state.InSistem) {
              localStorage.token = res.data.Token
              sessionStorage.removeItem('token')
            } else if (!state.InSistem) {
              localStorage.removeItem('token')
              sessionStorage.token = res.data.Token
            }

            router.push('/')
            state.SignInError = false
          } else {
            state.SignInError = true
            dispatch('setShowErrorModal', res.data)
          }
        })
    },
    setSignOut ({ state }) {
      axios.get(
        `${process.env.VUE_APP_URL_USERS}/Account/SignOut`,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${localStorage.token || sessionStorage.token}`
          }
        }
      ).then(() => {
        state.InSistem = false
        localStorage.removeItem('token')
        sessionStorage.removeItem('token')

        setTimeout(() => {
          router.push('/auth')
        }, 0)
      }).catch((error) => {
        console.log('error signOut', error)
      })
    }
  }
}
